import { render, staticRenderFns } from "./LavStatus.vue?vue&type=template&id=6f166610&scoped=true"
import script from "./LavStatus.vue?vue&type=script&lang=js"
export * from "./LavStatus.vue?vue&type=script&lang=js"
import style0 from "./LavStatus.vue?vue&type=style&index=0&id=6f166610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f166610",
  null
  
)

export default component.exports